// Angular
// noinspection JSUnusedGlobalSymbols

import { Component, OnInit } from '@angular/core';
// Widgets model
import {
  SparklineChartOptions,
  SubheaderService,
} from '../../../core/_base/layout';

import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../core/reducers';
import { currentUser, User } from '../../../core/auth';

@Component({
  selector: 'kt-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  chartOptions1: SparklineChartOptions;
  chartOptions2: SparklineChartOptions;
  chartOptions3: SparklineChartOptions;
  chartOptions4: SparklineChartOptions;

  user: Observable<User>;

  constructor(
    private subheaderService: SubheaderService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.subheaderService.setTitle('Πίνακας Ελέγχου');
    this.user = this.store.pipe(select(currentUser));
  }
}
